import { NavigationExtras } from "@angular/router";

export interface ApplicationSettings {
  startup: string | null | undefined;
}
